import { registerPlugin } from 'linkifyjs'
import { botcommand } from './botCommand.js'

registerPlugin('botcommand', botcommand)

export { botcommand }
